import script from "./CrmWorkListPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CrmWorkListPage.vue?vue&type=script&setup=true&lang=ts"

import "./CrmWorkListPage.vue?vue&type=style&index=0&id=14e4dd18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14e4dd18"]])

export default __exports__